import FilterCollapse from "./collapse/FilterCollapse";
import { IconFilter2X, IconFilterCancel } from "@tabler/icons-react";
import { useCategory } from "../../fetch/fetch.category";
import { EMPTY_CATEGORY } from "../../const/typeDefault/Category";
import ErrMessage from "../core/ErrMessage";
import { useSearchParamsHandler } from "../../hooks/useSearchParamsHandler";
import { useActiveParams } from "../../hooks/useActiveParams.ts";

const FilterContainer = () => {
  const { categorySlug } = useActiveParams();
  const { isActive, remove } = useSearchParamsHandler("filter");
  const { category, isLoading, isError } = useCategory(
    categorySlug,
    EMPTY_CATEGORY,
  );

  if (isError) return <ErrMessage message={isError} />;

  if (isLoading)
    return <span className="loading loading-spinner loading-xs"></span>;

  const filterIds = category.filters;

  if (filterIds.length === 0) {
    return (
      <div className="flex justify-center collapse rounded-box">
        <div className="badge badge-lg h-auto">
          Diese Kategorie stellt keine Filter zur verfügung
          <IconFilterCancel />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      {filterIds.map((value) => (
        <div
          key={value}
          className="collapse collapse-arrow glass-blurry bg-base-200"
        >
          <input type="checkbox" className="peer" />

          <FilterCollapse id={value} />
        </div>
      ))}
      <button
        className={`btn btn-error ${!isActive() && "btn-disabled"} transition-all`}
        onClick={() => remove()}
      >
        <IconFilter2X /> Alle Filter aufheben
      </button>
    </div>
  );
};
export default FilterContainer;
